import type { IntlShape } from "react-intl";
import { ApiError } from "./api.ts";

/** Maps an API error code to a localised message, falling back to a generic one. */
export function errorMessage(intl: IntlShape, err: unknown): string {
  const code = err instanceof ApiError ? err.code : typeof err === "string" ? err : null;
  const id = code ? `error.${code}` : null;
  if (id && intl.messages[id]) return intl.formatMessage({ id });
  return intl.formatMessage({ id: "app.error.generic" });
}
